import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { Divider } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 22,
    fontWeight: 600,
    paddingTop: 12,
    paddingBottom: 12,
  },
  close: {
    cursor: "pointer",
  },
  subTitle: {
    fontSize: 16,
    color: "#747474",
    fontWeight: 500,
  },
  contents: {
    padding: "16px 24px",
  },
  contPa: {
    paddingTop: 16,
    paddingBottom: 16,
  },
  case1: {
    flex: 1,
  },
  case2: {
    width: 250,
  },
  title1: {
    width: 40,
    color: "#747474",
    fontSize: 18,
    paddingRight: 24,
  },
  buttons: {
    float: "left",
    "& > .on": {
      color: theme.palette.primary.main,
      border: `1px solid ${theme.palette.primary.main}`,
    },
    "& > div": {
      display: "inline-block",
      fontSize: 18,
      width: 80,
      height: 36,
      marginRight: 16,
      cursor: "pointer",
      textAlign: "center",
      lineHeight: 2,
      border: "1px solid black",
    },
  },
  input1: {
    lineHeight: 2.3,
  },
  input2: {
    lineHeight: 2.3,
    paddingRight: 25,
  },
  textField1: {
    width: 120,
  },
  textField2: {
    width: 148,
  },
  title2: {
    fontSize: 20,
    fontWeight: 600,
    color: theme.palette.primary.main,
    height: 24,
    marginTop: 24,
    marginBottom: 8,
  },
  title3: {
    flex: 1,
    fontSize: 20,
  },

  footer: {
    paddingTop: 20,
    paddingBottom: 20,
  },
  button: {
    width: 768,
    height: 48,
  },
}));
const LungInputForm = ({
  sex,
  que1,
  que2,
  que3,
  que4,
  cm,
  age,
  kg,
  year,
  gap,
  setSex,
  setQue1,
  setQue2,
  setQue3,
  setQue4,
  handleClose,
  handleResult,
}) => {
  const classes = useStyles();
  return (
    <>
      <DialogTitle id="responsive-dialog-title">
        <Grid container alignItems="center" justify="space-between">
          <Grid className={classes.title}>폐암 위험도 자가진단</Grid>
          <Grid className={classes.close} onClick={handleClose}>
            <CloseIcon />
          </Grid>
        </Grid>
        <Grid className={classes.subTitle}>
          환자분의 폐암의 위험도를 먼저 체크해보시기 바랍니다.&nbsp;
          <br />
          아래 항목에 본인에게 맞게 체크해주시고 '계산하기' 버튼을 눌러주세요.
        </Grid>
      </DialogTitle>
      <Grid className={classes.contents}>
        <Grid
          container
          justify="space-between"
          alignItems="center"
          className={classes.contPa}
        >
          <Grid
            className={classes.case1}
            container
            alignItems="center"
            direction="row"
          >
            <Grid className={classes.title1}>성별11</Grid>
            <Grid className={classes.buttons}>
              <Grid
                onClick={() => setSex(true)}
                className={`${sex ? "on" : "off"}`}
              >
                {sex ? "✓" : ""} 남자
              </Grid>
              <Grid
                onClick={() => setSex(false)}
                className={`${!sex ? "on" : "off"}`}
              >
                {!sex ? "✓" : ""} 여자
              </Grid>
            </Grid>
          </Grid>
          <Grid
            className={classes.case2}
            container
            alignItems="center"
            direction="row"
          >
            <Grid className={classes.title1}>신장</Grid>
            <Grid className={classes.input1}>
              <TextField
                type="number"
                {...cm}
                inputProps={{
                  type: "number",
                  min: "0",
                  step: "1",
                }}
                className={classes.textField1}
                variant="outlined"
                size="small"
              />
              &nbsp;&nbsp;Cm
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          justify="space-between"
          alignItems="center"
          className={classes.contPa}
        >
          <Grid
            className={classes.case1}
            container
            alignItems="center"
            direction="row"
          >
            <Grid className={classes.title1}>연령</Grid>
            <Grid className={classes.input1}>
              <TextField
                className={classes.textField1}
                {...age}
                variant="outlined"
                inputProps={{
                  type: "number",
                  min: "0",
                  step: "1",
                }}
                size="small"
              />
              &nbsp;&nbsp;세
            </Grid>
          </Grid>
          <Grid
            className={classes.case2}
            container
            alignItems="center"
            direction="row"
          >
            <Grid className={classes.title1}>체중</Grid>
            <Grid className={classes.input1}>
              <TextField
                className={classes.textField1}
                variant="outlined"
                size="small"
                inputProps={{
                  type: "number",
                  min: "0",
                  step: "1",
                }}
                {...kg}
              />
              &nbsp;&nbsp;Kg
            </Grid>
          </Grid>
        </Grid>
        <Divider
          style={{ marginTop: 20, marginBottom: 16, background: "#c9d9ea" }}
        />
        <Grid className={classes.title2}>당뇨</Grid>
        <Grid container justify="space-between" alignItems="center">
          <Grid className={classes.title3}>당뇨가 있으신가요?</Grid>
          <Grid className={classes.buttons}>
            <Grid
              onClick={() => setQue1(true)}
              className={`${que1 ? "on" : "off"}`}
            >
              {que1 ? `✓` : ""} 예
            </Grid>
            <Grid
              onClick={() => setQue1(false)}
              className={`${!que1 ? "on" : "off"}`}
            >
              {!que1 ? "✓" : ""} 아니요
            </Grid>
          </Grid>
        </Grid>
        <Grid className={classes.title2}>폐기종</Grid>
        <Grid container justify="space-between" alignItems="center">
          <Grid className={classes.title3}>
            폐기종이나 만성폐쇄성폐질환을 겪으신 적이 있나요?
          </Grid>
          <Grid className={classes.buttons}>
            <Grid
              onClick={() => setQue2(true)}
              className={`${que2 ? "on" : "off"}`}
            >
              {que2 ? `✓` : ""} 예
            </Grid>
            <Grid
              onClick={() => setQue2(false)}
              className={`${!que2 ? "on" : "off"}`}
            >
              {!que2 ? "✓" : ""} 아니요
            </Grid>
          </Grid>
        </Grid>
        <Grid className={classes.title2}>결핵</Grid>
        <Grid container justify="space-between" alignItems="center">
          <Grid className={classes.title3}>결핵을 겪으신 적이 있나요?</Grid>
          <Grid className={classes.buttons}>
            <Grid
              onClick={() => setQue3(true)}
              className={`${que3 ? "on" : "off"}`}
            >
              {que3 ? `✓` : ""} 예
            </Grid>
            <Grid
              onClick={() => setQue3(false)}
              className={`${!que3 ? "on" : "off"}`}
            >
              {!que3 ? "✓" : ""} 아니요
            </Grid>
          </Grid>
        </Grid>
        <Grid className={classes.title2}>흡연</Grid>
        <Grid container justify="space-between" alignItems="center">
          <Grid className={classes.title3}>흡연을 해보셨나요?</Grid>
          <Grid className={classes.buttons}>
            <Grid
              onClick={() => setQue4(true)}
              className={`${que4 ? "on" : "off"}`}
            >
              {que4 ? `✓` : ""} 예
            </Grid>
            <Grid
              onClick={() => setQue4(false)}
              className={`${!que4 ? "on" : "off"}`}
            >
              {!que4 ? "✓" : ""} 아니요
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          justify="space-between"
          alignItems="center"
          style={{ marginTop: 30 }}
        >
          <Grid className={classes.title3}>
            흡연을 해보셨다면 몇 년 동안 흡연하셨나요?
          </Grid>
          <Grid className={classes.input2}>
            <TextField
              disabled={!que4}
              className={classes.textField2}
              {...year}
              inputProps={{
                type: "number",
                min: "0",
                step: "1",
              }}
              variant="outlined"
              size="small"
            />
            &nbsp;&nbsp;년
          </Grid>
        </Grid>
        <Grid
          container
          justify="space-between"
          alignItems="center"
          style={{ marginTop: 30 }}
        >
          <Grid className={classes.title3}>
            하루에 평균 몇 갑을 피우셨나요?
          </Grid>
          <Grid className={classes.input2}>
            <TextField
              disabled={!que4}
              className={classes.textField2}
              {...gap}
              inputProps={{
                type: "number",
                min: "0",
                step: "0.5",
              }}
              variant="outlined"
              size="small"
            />
            &nbsp;&nbsp;갑
          </Grid>
        </Grid>
      </Grid>
      <DialogActions>
        <Grid
          container
          justify="center"
          alignItems="center"
          className={classes.footer}
        >
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={handleResult}
          >
            계산하기
          </Button>
        </Grid>
      </DialogActions>
    </>
  );
};

export default LungInputForm;
